import React, { useEffect, useState } from "react"
import { useNavigate, useLocation, useParams } from "react-router-dom"

import AddCareplan from "@fitpeo/fit-plan-creator"
import { useToasts } from "react-toast-notifications"

import { useDispatch, useSelector } from "react-redux"
import { getPatientDiagnosticsData } from "../../../redux/actions/patientAction"
import { postPcmPlan } from "../../../redux/actions/pcmActions"

import Loading from "../../layouts/Loading/Loading"

import "./PCMAdminPatient.css"

const PCM_CAREPLAN_ADD_SUCCESS_MSG = "Principal Care Plan Added Successfully"
const PCM_CAREPLAN_ADD_ERR_MSG = "Unable To Add Principal Care Plan!"

const PCMAdminPatient = ({ isFromAddPatient }) => {
  const dispatch = useDispatch()

  const [answers, setAnswers] = useState(null)
  const [addingBy, setAddingBy] = useState([])

  const location = useLocation()
  const patientId = location?.state?.id
  const patientNameObj = location?.state?.patientNameObj
  const provider = location?.state?.provider
  const practitioner = location?.state?.practitioner
  const pcmMonitorId = location?.state?.pcmMonitorId
  const dob = location?.state?.dob

  const navigate = useNavigate()
  const { addToast } = useToasts()
  const {orgId, orgName} = useParams()

  useEffect(() => {
    if (patientId !== undefined) {
      dispatch(getPatientDiagnosticsData({ patientId }))
    } else navigate(`/${orgId}/${orgName}/pcm/patients`)
  }, [dispatch, patientId])

  const { userInfo: adminInfo } = useSelector(state => state.userInfo)
  const { loading: diagnosticsLoading, patientDiagnosticData } = useSelector(
    state => state.patientDiagnosticData
  )
  const { loading: postPcmLoading } = useSelector(state => state.postPCMData)

  useEffect(() => {
    if (!adminInfo) return

    setAddingBy({
      id: adminInfo?.id,
      name: adminInfo?.middleName
        ? `${adminInfo?.firstName} ${adminInfo?.middleName ? adminInfo?.middleName : ""} ${adminInfo?.lastName}`
        : `${adminInfo?.firstName} ${adminInfo?.lastName}`,
      userType: "caretaker"
    })
  }, [adminInfo])

  const submitForm = async () => {
    const postCarePlan = await dispatch(
      postPcmPlan({ patientId, pcmMonitorId, formInputs: answers })
    )
    if (postCarePlan?.status === 200) {
      setAnswers(null)
      addToast(PCM_CAREPLAN_ADD_SUCCESS_MSG, { appearance: "success", autoDismiss: true })

      setTimeout(() => {
        setAnswers(null)
        window.location.href = `/${orgId}/${orgName}/pcm/patients`
      }, 1000)
    } else {
      addToast(PCM_CAREPLAN_ADD_ERR_MSG, { appearance: "error", autoDismiss: true })
    }
  }

  useEffect(() => {
    if (!answers) return
    submitForm()
  }, [answers]) //eslint-disable-line

  return diagnosticsLoading ? (
    <Loading />
  ) : (
    patientDiagnosticData && provider && practitioner && patientNameObj && dob && patientId && isFromAddPatient && (
      <AddCareplan
        patientInfoDetail={{ ...patientNameObj, dob, id: patientId }}
        diagnosticData={patientDiagnosticData}
        type="pcm"
        answers={answers}
        setAnswers={setAnswers}
        navigate={navigate}
        navigateUrl={`/${orgId}/${orgName}/pcm/patients`}
        providers={provider}
        practitioners={practitioner}
        addingBy={addingBy}
        submissionLoading={postPcmLoading}
      />
    )
  )
}

export default PCMAdminPatient
